<div>
  <div class="modal-header">
    <h4
      *ngIf="activeFile"
      class="modal-title pull-left"
      tooltip="{{ activeFile.name }}"
    >
      <span class="lightbox-image-name">{{ activeFile.name }}</span>
      <br />
      <span class="lightbox-image-coutner">{{ subtitle }}</span
      ><br />
    </h4>
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div
    class="modal-body modal-body-lightbox"
    ngResizable
    [rzHandles]="'n,s'"
    (rzResizing)="onResizing()"
  >
    <div class="p-lightbox">
      <div class="inner">
        <rr-overlay-spinner
          [spinnerStatus]="spinnerStatus"
        ></rr-overlay-spinner>
        <div class="lightbox-controllers">
          <button
            *ngIf="!btnPrevHide"
            type="button"
            class="btn-arrow-left"
            (click)="prevClick()"
            [disabled]="btnPrevDisabled"
          >
            <span class="oi oi-chevron-left"></span
            ><span class="title">prev</span>
          </button>
          <button
            *ngIf="!btnNextHide"
            type="button"
            class="btn-arrow-right"
            (click)="nextClick()"
            [disabled]="btnNextDisabled"
          >
            <span class="oi oi-chevron-right"></span
            ><span class="title">next</span>
          </button>
        </div>

        <div *ngIf="activeFile">
          <div *ngIf="editorType === 'image'">
            <!-- editorType = 'image'; // 'json', '3d', 'text' -->

            <div class="image-container">
              <a (click)="downloadFile(activeFile)"
                ><span class="oi oi-data-transfer-download"></span
              ></a>
              <img
                src="{{ activeFile.url }}"
                (load)="closeLoader()"
                title="{{ showImageStats ? imageTooltip : activeFile.name }}"
                alt="{{ showImageStats ? imageTooltip : activeFile.name }}"
              />
            </div>
          </div>
          <div *ngIf="editorType === 'text'">
            <div class="text-container text-editor">
              <div class="inner" [innerHtml]="activeFile.text"></div>
            </div>
          </div>
          <div *ngIf="editorType === 'json'">
            <div class="json-editor">
              <json-editor
                [options]="jsonEditorOptions"
                [data]="jsonData"
              ></json-editor>
            </div>
          </div>
          <div class="obj-webviewer" *ngIf="editorType === 'obj'">
            <!-- <rr-webviewer
              [jsonFile]="jsonFile"
              [settings]="webviewerSettings"
              [resize]="resizeing"
              [showControlls]="showControlls"
              (loadingStarted)="loadingStarted()"
              (loadingSuccess)="loadingSuccess()"
              (controllerNumber)="controllerNumber($event)"
            ></rr-webviewer> -->

            <button
              class="btn btn-outline-secondary btn-sm show-hide-controlls"
              type="button"
              (click)="showHideControlls()"
            >
              {{ showControlls ? 'Hide Controlls' : 'Show Controlls' }} ({{
                controllerCounter
              }})
            </button>
          </div>

          <div class="json-webviewer" *ngIf="editorType === 'json3d'">
            <!-- <rr-webviewer
              [jsonFile]="jsonFile"
              [settings]="webviewerSettings"
              [resize]="resizeing"
              [showControlls]="showControlls"
              (loadingStarted)="loadingStarted()"
              (loadingSuccess)="loadingSuccess()"
              (controllerNumber)="controllerNumber($event)"
            ></rr-webviewer> -->

            <button
              class="btn btn-outline-secondary btn-sm show-hide-controlls"
              type="button"
              (click)="showHideControlls()"
            >
              {{ showControlls ? 'Hide Controlls' : 'Show Controlls' }} ({{
                controllerCounter
              }})
            </button>
          </div>

          <div
            class="garment-avatar-viewer"
            *ngIf="editorType === 'avatar' || editorType === 'garment'"
          >
            <!-- <rr-avatar-garment-viewer
              [fileUrl]="activeFile.url"
              [fileExtension]="fileExtension"
              [renderServerUrl]="renderServerUrl"
              (loadingSuccess)="loadingSuccess()"
              (loadingStarted)="loadingStarted()"
            >
            </rr-avatar-garment-viewer> -->
          </div>
        </div>
        <br />
      </div>
    </div>
  </div>
</div>
